'use client';

import type React from 'react';
import Image from 'next/image';
import { Card } from '../../components/card';
import IconBar from '../../components/hero/icon_bar';
import HeroCardClient from '../../components/hero/hero_card_client';
import { ProductLine } from '../../helpers/home_services.helper';
import LogRocketInitializer from '../logrocket';

export default function WindowsHeroSection() {
  return (
    <div className="w-full overflow-hidden" id="hero">
      {/* Shared Background Images */}
      <LogRocketInitializer />
      <div className="relative w-full h-[240px] md:h-[700px]">
        <Image
          src="/placeholder.webp"
          alt="Hero background"
          fill
          priority
          className="object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />

        {/* Mobile Title */}
        <div className="md:hidden absolute inset-0 flex justify-center text-center">
          <h1 className="text-white text-2xl font-semibold p-4 mt-8">
            Compare Top Window Brands And Get Local Quotes Instantly
          </h1>
        </div>

        {/* Desktop Content */}
        <div className="hidden md:block relative z-10 container px-1 py-28 max-w-5xl mx-auto">
          <div className="flex flex-row gap-8 items-start">
            <div className="w-1/2 text-white">
              <h1 className="text-5xl font-bold mb-4">
                Compare Window Replacement Costs
                <br />
                Near You
              </h1>
              <p className="text-xl mb-8">
                Compare Top Window Brands and Get Local Quotes Instantly
              </p>
              <div className="pr-4">
                <IconBar />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Shared Card and IconBar (with responsive positioning) */}
      <div className="relative z-10 px-4 md:px-0 -mt-12 md:-mt-2 flex justify-center md:absolute md:left-1/2  md:top-[200px]">
        <Card className="rounded-xl shadow-lg bg-white border-0 w-full md:w-[520px] min-h-[410px]">
          <HeroCardClient
            productLine={ProductLine.Windows}
            cardTitle="Compare Window Replacement Costs Today!"
          />
        </Card>
      </div>

      {/* Mobile IconBar below the form */}
      {/* <div className="md:hidden mt-4 px-4">
        <IconBar />
      </div> */}
    </div>
  );
}
